import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { DeleteOutlined } from "@mui-symbols-material/w300"
import React from "react"

interface ProductDropdownMenuProps {
  anchorEl: HTMLElement | null
  onClose: () => void
  open: boolean
  onRemoveInstruction: () => void
}

const MENU_ICON_PROPS = {
  fontVariationSettings: '"wght" 300',
}

const ProductDropdownMenu: React.FC<ProductDropdownMenuProps> = ({ anchorEl, onClose, open, onRemoveInstruction }) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      slotProps={{
        paper: {
          className: "w-[220px]",
        },
      }}
    >
      <MenuItem onClick={onRemoveInstruction}>
        <ListItemIcon>
          <DeleteOutlined sx={MENU_ICON_PROPS} />
        </ListItemIcon>
        <ListItemText primary='Remove Instruction' />
      </MenuItem>
    </Menu>
  )
}

export default ProductDropdownMenu
